<!-- 课表查询 -->
<template>
    <div class="el-timetableQuery">
        <el-row class="page_content">
            <h1 class="head_title">调查问卷</h1>
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="是否填写">
                    <el-select v-model="form.fillStatus" :filterable="true" @change="selectScore" placeholder="请选择学期">
                        <el-option label="所有" value=""></el-option>
                        <el-option label="已填写" value="1"></el-option>
                        <el-option label="未填写" value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-table
                :data="tableData"
                border
                style="width: 100%;">
                <el-table-column
                    prop="surveyTitle"
                    header-align="center"
                    align="center"
                    label="标题">
                </el-table-column>
                <el-table-column
                    prop="surveyStudentAddTime"
                    header-align="center"
                    align="center"
                    width="180"
                    label="发布时间">
                </el-table-column>
                <el-table-column
                    prop="surveyStudentUpdateTime"
                    header-align="center"
                    align="center"
                    width="180"
                    label="填写时间">
                </el-table-column>
                <el-table-column
                    prop="surveyAddTime"
                    header-align="center"
                    align="center"
                    width="100"
                    label="状态">
                    <template slot-scope="scope">
                        <template v-if="scope.row.surveyForbidden == 1">
                            <span style="color: red;">停用</span>
                        </template>
                        <template v-if="scope.row.surveyForbidden == 2">
                            <template v-if="scope.row.fillStatus == 2">
                                <span style="color: orange;">待填写</span>
                            </template>
                            <template v-if="scope.row.fillStatus == 1">
                                <span style="color: #409EFF;">已填写</span>
                            </template>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    width="150"
                    label="操作">
                    <template slot-scope="scope">
                        <template v-if="scope.row.surveyForbidden == 1">
                            -
                        </template>
                        <template v-if="scope.row.surveyForbidden == 2">
                            <template v-if="scope.row.fillStatus == 2">
                                <el-link type="primary" :underline="false" @click="selectData(scope.row)">立即填写</el-link>
                            </template>
                            <template v-if="scope.row.fillStatus == 1">
                                <el-link type="primary" :underline="false" @click="selectData(scope.row)">查看</el-link>
                            </template>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <div class="block" style="text-align: center;position: absolute;bottom: 0;width: 96%;margin-bottom: 20px;">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage1"
                    :page-size="limit"
                    :hide-on-single-page="true"
                    layout="total, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </el-row>
    </div>
</template>
<script>
export default {
  name: "QuestionnaireList",
  data() {
    return {
      form:{
          fillStatus:""
      },
      tableData: [],
      submitBut:false,
      currentPage1: 1,
      total: 0,
      limit:6,
      page:1
    };
  },
  created() {
    this.getSurveyList();
  },
  methods: {
      handleSizeChange(val) {
          console.log(`每页 ${val} 条`);
          this.limit = val;
          this.getSurveyList();
      },
      handleCurrentChange(val) {
          console.log(`当前页: ${val}`);
          this.page = val;
          this.getSurveyList();
      },
    getSurveyList(){ //获取List
        let param = this.form;
        param.limit = this.limit;
        param.page = this.page;
      this.$store.dispatch("user/getSurveyList",this.form).then((ret) => {
        if (ret.code === 0 || ret.code === '0') {
          this.tableData = ret.data;
          this.total = ret.count;
        } else {
          this.$message({
             message: ret.msg,
             type: 'warning'
          });
        }
      })
    },
    selectScore(v){
      this.getSurveyList();
    },
    selectData(item){ //立即填写或者查看
        let url = this.$baseUrl + "/surveyIndex.do?idInfo="+item.surveyId+"&needLogin="+(item.needLogin == 1?"YES":"NO");
        this.$openWithRoleTag(url);
    }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-timetableQuery{
    .wd{
        color: @red;
    }
    .el-dialog__body{
        border-top:1px solid #ebeef5;
    }
    .el-descriptions-item__container{
        font-size: 17px;
    }
    .el-descriptions-item__label {
        white-space: nowrap;
        width: 140px;
        text-align: right;
    }
    .el-descriptions-item__content{
        max-height: 200px;
        overflow: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/questionnaire/QuestionnaireList.vue